import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { protectedResources } from 'src/app/b2c-config';

@Injectable({
  providedIn: 'root'
})

export class ManageDeviceService {

  constructor(private http: HttpClient) { }
  public apiResponse: any;
  public countryDataStatic:any = [];
  public productTypesStatic:any = [];
  public deviceDeleted = false;
  public productDataStatic:any = [];

  public getCountryData(): Observable<any> {
    return this.http.get(`${protectedResources.etlApi.endpoint}api/UserManagement/GetCountriesWithRegion`);
  }
  public getProductTypes(): Observable<any> {
    return this.http.get(`${protectedResources.etlApi.endpoint}api/UserManagement/GetProductTypes`);
  }

  public registerDevice(deviceRegistrationData: any, internalEmails: any | undefined | null, externalEmails: any | undefined | null,
    selectedCountry: any | undefined, selectedProduct: any | undefined, dataKey) {
    let dataToSubmit = {
      serialNumber: deviceRegistrationData.serialNumber,
      product: selectedProduct.shortName,
      customer: deviceRegistrationData.customerName,
      address: deviceRegistrationData.address || null,
      labName: deviceRegistrationData.labName || null,
      operator: deviceRegistrationData.operatorName || null,
      city: deviceRegistrationData.city || null,
      state: deviceRegistrationData.state || null,
      postCode: deviceRegistrationData.zipCode || null,
      country: selectedCountry.shortName,
      phoneNumber: deviceRegistrationData.phoneNumber || null,
      externalEmailAddress: externalEmails?.map(x => x.text) || [],
      internalEmailAddress: internalEmails?.map(x => x.text) || []
    };

    if(dataKey){      
      return this.http.post(`${protectedResources.realizerApi.endpoint}api/Device/PreRegisterDevice`, { ...dataToSubmit });
    }
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/Device/RegisterDevice`, { ...dataToSubmit });
  }

  public getAllProducts(): Observable<any> {
    return this.http.get(`${protectedResources.etlApi.endpoint}api/Device/GetProductDetails`);
  }

  public deRegisterDevice(deregistrationData){
    this.deviceDeleted = true; 
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/Device/DeRegisterDevice`, deregistrationData, {observe: 'response'});
  }

  public deleteStandaloneDevice(standaloneAsset){
    this.deviceDeleted = true;
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/Device/DeleteSA`, standaloneAsset);
  }

  public manuallyRegisterDevice(registrationData){
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/Device/manual-register`,registrationData)
  }

  public deleteDeviceFromIoT(registrationData){
    this.deviceDeleted = true;
    console.log(`${protectedResources.realizerApi.endpoint}api/Device/deregister`);
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/Device/deregister`,registrationData)
  }
}
